import React, { useContext, useEffect, useRef, useState } from "react";
import Footer from "../Components/Footer";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Menubar from "../Components/Menubar";
import Totop from "../Components/Totop";
import "./Main.css";
import "../../index.css";
import { MediaQueryContext } from "../../context";
import main_sub5 from "../../assets/images/00main/main-sub5.svg";
import main_sub6 from "../../assets/images/00main/main-sub6.svg";
import main2 from "../../assets/images/00main/main2.png";
import serviceimg1 from "../../assets/images/03rpm/service1.svg";
import serviceimg2 from "../../assets/images/03rpm/service2.svg";
import serviceimg3 from "../../assets/images/03rpm/service3.svg";
import larsCareImg from "../../assets/images/03rpm/lars_care.svg";
import riskPredictionImg from "../../assets/images/03rpm/risk_prediction.svg";
import { DEFAULT_LANG } from "../../i18n";

const getLangFromPath = (pathname) => {
  const m = pathname.match(/^\/(kr|en)(\/|$)/);
  return m ? m[1] : DEFAULT_LANG;
};

const renderMultiline = (text) =>
  text.split("\n").map((line, i, arr) => (
    <React.Fragment key={i}>
      {line}
      {i < arr.length - 1 && <br />}
    </React.Fragment>
  ));

export default function Main(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const lang = getLangFromPath(useLocation().pathname);
  const goto = (p) => history.push(`/${lang}${p}`);

  const { mTablet } = useContext(MediaQueryContext);

  const executeScroll = () => {
    const element = document.getElementById(props.location.hashId);
    const headOffset = mTablet ? 84 : 184;
    const elementPosition = element?.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - headOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    executeScroll();
  }, [props.location.update]);

  const solutionItems = [
    { img: serviceimg1, key: "ostoCare", link: "/rpmsolution" },
    { img: serviceimg2, key: "atti", link: "/rpmsolution" },
    { img: larsCareImg, key: "larsCare", link: "/rpmsolution" },
    { img: serviceimg3, key: "healiary", link: "/healthcare" },
    { img: riskPredictionImg, key: "riskPrediction", link: "/healthcare" },
  ];

  const carouselRef = useRef(null);
  const [carouselIdx, setCarouselIdx] = useState(0);
  const visibleCount = mTablet ? 1 : 3;
  const maxIdx = Math.max(0, solutionItems.length - visibleCount);

  const scrollCarousel = (dir) => {
    const next = dir === "left"
      ? Math.max(0, carouselIdx - 1)
      : Math.min(maxIdx, carouselIdx + 1);
    setCarouselIdx(next);
  };

  return (
    <div id="main" style={{ height: "100%" }}>
      <Menubar slideIndex={0} />
      <Totop />
      <div className="main-container">
        <>
          <div className="mainlayout">
            <div className="maintext ">
              <p>
                <span style={{ color: "#F88001" }}>HERINGS</span>{t("main.hero.line1")}
                <br />
                {t("main.hero.line2")}
                <br /> {t("main.hero.line3")}
                <br />{" "}
                <span style={{ color: "#F88001" }}>
                  {t("main.hero.line4")}
                </span>
              </p>
            </div>
          </div>
          <div className="mainlayout2">
            <img
              src={main2}
              alt="main2"
              className="mainsublayout2"
            />
            <div>
              <p className="maintext2 ">
                <p
                  style={{
                    color: "#F68C29",
                    fontSize: "clamp(1rem, 1.65vw, 2rem)",
                    fontWeight: "700",
                    textTransform: "uppercase",
                  }}
                >
                  {" "}
                  {t("main.intro.label")}
                </p>
                {renderMultiline(t("main.intro.body"))}
              </p>
            </div>
          </div>
          {/* Service Categories */}
          <div className="mainlayoutImage mainlayout3">
            <div className="mainsublayout3">
              <img src={main_sub5} alt="RPM" className="subImage" />
              <div className="mainsub3">
                <div>
                  <p className="maintext3">
                    {renderMultiline(t("main.categories.rpm.title"))}
                  </p>
                  <p className="subContent2">{t("main.categories.rpm.desc")}</p>
                </div>
                <div
                  className="moveButton"
                  onClick={() => goto("/rpmsolution")}
                >
                  {t("main.categories.rpm.btn")}
                </div>
              </div>
            </div>
            <div className="mainsublayout3 itemRight">
              <div className="mainsub3">
                <div>
                  <p className="maintext3">
                    {renderMultiline(t("main.categories.healthcare.title"))}
                  </p>
                  <p className="subContent2">{t("main.categories.healthcare.desc")}</p>
                </div>
                <div
                  className="moveButton itemRight"
                  style={{ textAlign: "center" }}
                  onClick={() => goto("/healthcare")}
                >
                  {t("main.categories.healthcare.btn")}
                </div>
              </div>
              <img src={main_sub6} alt="Healthcare" className="subImage" />
            </div>
            <div className="mainsublayout3">
              <img src={main_sub5} alt="Research" className="subImage" />
              <div className="mainsub3">
                <div>
                  <p className="maintext3">
                    {renderMultiline(t("main.categories.research.title"))}
                  </p>
                  <p className="subContent2">{t("main.categories.research.desc")}</p>
                </div>
                <div
                  className="moveButton"
                  onClick={() => goto("/clinicalresearch")}
                >
                  {t("main.categories.research.btn")}
                </div>
              </div>
            </div>
          </div>

          {/* Solutions Carousel */}
          <div className="solutions-section">
            <div className="solutions-header">
              <p className="solutions-label">{t("main.solutions.label")}</p>
              <p className="solutions-title">{t("main.solutions.title")}</p>
            </div>
            <div className="carousel-wrapper">
              <button
                className={`carousel-arrow carousel-arrow-left ${carouselIdx === 0 ? "carousel-arrow-disabled" : ""}`}
                onClick={() => scrollCarousel("left")}
                disabled={carouselIdx === 0}
              >
                &#8592;
              </button>
              <div className="carousel-viewport" ref={carouselRef}>
                <div
                  className="carousel-track"
                  style={{
                    transform: `translateX(-${carouselIdx * (100 / visibleCount)}%)`,
                  }}
                >
                  {solutionItems.map((item, i) => (
                    <div
                      key={i}
                      className="solution-card"
                      style={{ flex: `0 0 ${100 / visibleCount}%` }}
                      onClick={() => goto(item.link)}
                    >
                      <div className="solution-card-inner">
                        <div className="solution-card-img-wrap">
                          <img
                            src={item.img}
                            alt={t(`main.solutions.items.${item.key}.title`)}
                            className="solution-card-img"
                          />
                        </div>
                        <div className="solution-card-body">
                          <p className="solution-card-title">
                            {t(`main.solutions.items.${item.key}.title`)}
                          </p>
                          <p className="solution-card-desc">
                            {t(`main.solutions.items.${item.key}.desc`)}
                          </p>
                          <span className="solution-card-link">
                            {t("main.solutions.learnMore")} &rsaquo;
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <button
                className={`carousel-arrow carousel-arrow-right ${carouselIdx >= maxIdx ? "carousel-arrow-disabled" : ""}`}
                onClick={() => scrollCarousel("right")}
                disabled={carouselIdx >= maxIdx}
              >
                &#8594;
              </button>
            </div>
            <div className="carousel-dots">
              {solutionItems.map((_, i) => (
                <span
                  key={i}
                  className={`carousel-dot ${i >= carouselIdx && i < carouselIdx + visibleCount ? "carousel-dot-active" : ""}`}
                  onClick={() => setCarouselIdx(Math.min(i, maxIdx))}
                />
              ))}
            </div>
          </div>
        </>
      </div>
      <div className="contact-banner">
        <div className="contact-banner-inner">
          <div className="contact-banner-left">
            <p className="contact-banner-label">{t("main.contact.label")}</p>
            <p className="contact-banner-title">
              {renderMultiline(t("main.contact.title"))}
            </p>
            <p className="contact-banner-subtitle">
              {t("main.contact.subtitle")}
            </p>
          </div>
          <div className="contact-banner-right">
            <div className="contact-banner-card">
              <div className="contact-banner-card-item">
                <span className="contact-banner-card-label">{t("main.contact.emailLabel")}</span>
                <span className="contact-banner-card-value">herings@heringsglobal.com</span>
              </div>
              <div className="contact-banner-card-item">
                <span className="contact-banner-card-label">{t("main.contact.addressLabel")}</span>
                <span className="contact-banner-card-value">
                  {renderMultiline(t("main.contact.address"))}
                </span>
              </div>
              <div
                className="contact-banner-btn"
                onClick={() => goto("/contactus")}
              >
                {t("main.contact.btn")}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
